const DATE_TAG = '$date'
const NUMBER_TAG = '$number'
const OUTSIDE_PRINTABLE_ASCII = /[^\x20-\x7e]/g

export function toTaggedJson(value: unknown): string {
  return JSON.stringify(value, tagSpecialValues).replace(
    OUTSIDE_PRINTABLE_ASCII,
    unicodeEscape
  )
}

export function fromTaggedJson<T>(text: string): T {
  return JSON.parse(text, untagSpecialValues) as T
}

function tagSpecialValues(
  this: Record<string, unknown>,
  key: string,
  value: unknown
): unknown {
  const original = this[key]
  if (original instanceof Date) return { [DATE_TAG]: original.getTime() }
  if (typeof value !== 'number') return value
  if (!Number.isFinite(value)) return { [NUMBER_TAG]: String(value) }
  if (Object.is(value, -0)) return { [NUMBER_TAG]: '-0' }
  return value
}

function untagSpecialValues(_key: string, value: unknown): unknown {
  if (!isTag(value)) return value
  if (DATE_TAG in value) return new Date(value[DATE_TAG] as number)
  return Number(value[NUMBER_TAG])
}

function isTag(value: unknown): value is Record<string, unknown> {
  if (typeof value !== 'object' || value === null) return false
  const keys = Object.keys(value)
  if (keys.length !== 1) return false
  const tagged = (value as Record<string, unknown>)[keys[0]]
  if (keys[0] === DATE_TAG) return typeof tagged === 'number'
  return keys[0] === NUMBER_TAG && typeof tagged === 'string'
}

function unicodeEscape(character: string): string {
  return `\\u${character.charCodeAt(0).toString(16).padStart(4, '0')}`
}
